// Libs
import _ from 'lodash'

import {
  CHANGE_FILTER_PANEL_VISIBLE,
  CHANGE_FILTER_PANEL_LOADING,
  CHANGE_FILTER_PANEL_PARAMS,
  TOGGLE_FILTER_PANEL_OPTION,
  TOGGLE_FILTER_PANEL_ALL,
  RESET_FILTER_PANEL_PARAMS
} from './actions'

const initialState = {
  visible: false,
  loading: false,
  period: {
    options: [{ label: 'Hoje', value: 'today' }, { label: 'Ontem', value: 'yesterday' }, { label: 'Esta Semana', value: 'thisWeek' }, { label: 'Semana Passada', value: 'lastWeek' }, { label: 'Este Mês', value: 'thisMonth' }, { label: 'Mês Passado', value: 'lastMonth' }, { label: 'Este Ano', value: 'thisYear' }, { label: 'Ano Passado', value: 'lastYear' }, { label: 'Últimos 15 Dias', value: 'last15days' }, { label: 'Últimos 30 Dias', value: 'last30days' }, { label: 'Últimos 60 Dias', value: 'last60days' }, { label: 'Últimos 90 Dias', value: 'last90days' }],
    selected: []
  },
  companies: {
    options: [],
    selected: []
  },
  lawFirms: {
    options: [],
    selected: []
  },
  regions: {
    options: [{ label: 'AC', value: 'AC' }, { label: 'AL', value: 'AL' }, { label: 'AP', value: 'AP' }, { label: 'AM', value: 'AM' }, { label: 'BA', value: 'BA' }, { label: 'CE', value: 'CE' }, { label: 'DF', value: 'DF' }, { label: 'ES', value: 'ES' }, { label: 'GO', value: 'GO' }, { label: 'MA', value: 'MA' }, { label: 'MT', value: 'MT' }, { label: 'MS', value: 'MS' }, { label: 'MG', value: 'MG' }, { label: 'PA', value: 'PA' }, { label: 'PB', value: 'PB' }, { label: 'PR', value: 'PR' }, { label: 'PE', value: 'PE' }, { label: 'PI', value: 'PI' }, { label: 'RJ', value: 'RJ' }, { label: 'RN', value: 'RN' }, { label: 'RS', value: 'RS' }, { label: 'RO', value: 'RO' }, { label: 'RR', value: 'RR' }, { label: 'SC', value: 'SC' }, { label: 'SP', value: 'SP' }, { label: 'SE', value: 'SE' }, { label: 'TO', value: 'TO' }],
    selected: []
  },
  classifiers: {
    options: [],
    selected: []
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_FILTER_PANEL_VISIBLE:
      return { ...state, visible: action.payload }
    case CHANGE_FILTER_PANEL_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    case CHANGE_FILTER_PANEL_PARAMS:
      const { lawFirmId, selectedPeriod, companies, lawFirms, classifiers = [] } = action.payload
      let legalDepartment = { label: 'Departamento Jurídico', value: 'None' }
      let noClassifiers = { label: 'Sem Classificador', value: 'None' }

      return {
        ...state,
        period: { ...state.period, selected: !_.isEmpty(selectedPeriod) ? selectedPeriod : [[...state.period.options][9]] },
        companies: {
          options: [...companies],
          selected: [...companies]
        },
        classifiers: {
          options: _.isEmpty(classifiers) ? [] : [...classifiers, noClassifiers],
          selected: _.isEmpty(classifiers) ? [] : [...classifiers, noClassifiers]
        },
        lawFirms: {
          options: lawFirmId ? [...lawFirms] : [...lawFirms, legalDepartment],
          selected: lawFirmId ? [...lawFirms] : [...lawFirms, legalDepartment]
        },
        regions: { ...state.regions, selected: [...state.regions.options] }
      }
    case TOGGLE_FILTER_PANEL_OPTION:
      const { option, key, multiple } = action.payload
      const index = state[key].selected.indexOf(option)

      if (index === -1) {
        // Check an option
        return {
          ...state,
          [key]: {
            ...state[key],
            selected: multiple ? [...state[key].selected, option] : [option]
          }
        }
      } else {
        // Uncheck an option
        if (state[key].selected.length > 1) {
          state[key].selected.splice(index, 1)

          return {
            ...state,
            [key]: {
              ...state[key],
              selected: multiple ? state[key].selected : [option]
            }
          }
        }
        return { ...state }
      }
    case TOGGLE_FILTER_PANEL_ALL:
      if (state[action.payload].options.length === state[action.payload].selected.length &&
        state[action.payload].selected.length > 1) {
        return {
          ...state,
          [action.payload]: {
            ...state[action.payload],
            selected: []
          }
        }
      }

      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          selected: [...state[action.payload].options]
        }
      }
    case RESET_FILTER_PANEL_PARAMS:
      return { ...initialState }
    default:
      return state
  }
}
